import { ref } from 'vue'
import { api } from '@/api'
import { $formatErrorMessage } from '@/helpers'
import { useLoadingStore, useToastStore } from '@/stores'
import { useElementClick } from '@/composables/tracks/useElementClick'

interface Book {
  contentId: string
  contentChapterId: string
  bookName: string
  chapterName: string
  serialStatus: number
}

export function usePurchase(Scenario: string, book?: Book) {
  const templateProducts = ref<any>([])
  const data = ref<any>({})
  const PayTemplateSuccess = ref(false)
  const loading = ref(false)

  const { $toast } = useToastStore()
  const { $showLoading, $hideLoading } = useLoadingStore()
  const { elementClickForPay } = useElementClick()

  const getTopUpList = async function () {
    loading.value = true
    try {
      const res: any = await api.get<any>('/member/topup/product/list', {
        params: {
          type: book?.contentId ? 1 : 2,
          contentId: book?.contentId || '',
          contentChapterId: book?.contentChapterId || '',
        },
      })
      data.value = res.data || {}
      templateProducts.value = res.data || []
    }
    catch (error) {
      $toast($formatErrorMessage(error))
    }
    loading.value = false
  }

  const PayTemplate = async function (item: any) {
    elementClickForPay('purchase', {
      purchaseId: item.payConfigId,
      commodityId: item.productId,
      purchaseType: '1',
      price: item.price,
      paymentChannel: 'paypal',
      purchaseScenario: Scenario, // store chapter
    })

    $showLoading()
    const url = `${window.location.origin}/paying?redirect_source=${encodeURIComponent(window.location.href)}`
    const params = {
      payConfigId: item.payConfigId,
      productId: item.productId,
      contentId: book?.contentId,
      contentChapterId: book?.contentChapterId,
      memberCurrencyCode: 'usd',
      payType: 6,
      type: 2,
      successUrl: `${url}&payment_status=success`,
      cancelUrl: `${url}&payment_status=cancel`,
    }
    try {
      const { data } = await api.post<any>('/member/topup/createPaypalPaymentIntent', params)
      PayTemplateSuccess.value = true
      window.location.href = data
    }
    catch (error) {
      $toast($formatErrorMessage(error))
    }
    $hideLoading()
  }

  getTopUpList()

  return {
    templateProducts,
    data,
    PayTemplateSuccess,
    loading,
    PayTemplate,
  }
}
